'use strict';

import React, { Component } from 'react';
import mime from 'mime'
import { Button, IconButton } from '@material-ui/core';
import { CloudDownloadRounded } from '@material-ui/icons';

class FileSAV extends Component {
    state = {
        src: "",
    }
    componentDidMount = async () => {            
        try {
            const req = await fetch('/sav/getFile', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({src: this.props.src}),
                credentials: 'same-origin'
            });
            const src = await req.json();
            console.log(src);
            if (src.error) {
                console.log("[ERROR], getting prospect response ", src)
                return;
            }
            this.setState({
                src: src,
            });
        } catch (err) {
            console.log("[ERROR], fetching file", err)
        }
    }
    render() {
        //console.log('Info on photo : ',this.state);
        let { name, ext, image, pdf, csv, other, mime } = this.props;
        let csvContent = ""
        let encoded = ""
        
        let fileName = name.replace(/\s+/g, '_')
        if (mime){
            if( mime === "pdf"){
                pdf = true
                other = false
            } else if( mime.startsWith("image")){
                image = true
                other = false
            } else if( mime === "csv"){
                csv = true
                other = false
            }  
        }
        if(this.props.csv){
            csvContent = `data:text/csv;charset=utf-8,${this.state.src}`
            encoded = encodeURI(csvContent);
        }
        console.log('====================================');
        console.log("[PROPS] IMAGE", this.props);
        console.log('====================================');
        return (
            <div>

            { image &&
                <div
                className="img-responsive" style={{height: "120px"}}>
                    <a href={"/download/document/sav/"+this.props.src} download={fileName}>
                        <img className="img-responsive" style={{height:"100%"}} src={this.state.src} alt={fileName}/>
                    </a>
                </div>
            }
            { pdf &&
                <div >
                    <a href={"/download/document/sav/"+this.props.src} download={`${fileName}.${ ext || "pdf"}`}>
                        <IconButton color="secondary" title="Télécharger"><CloudDownloadRounded /></IconButton>
                    </a>
                </div>
            }
            { csv &&
                <div>
                    <a href={"/download/document/sav/"+this.props.src} download={`${fileName}.csv`}>
                    <IconButton color="secondary" title="Télécharger"><CloudDownloadRounded /></IconButton>
                    </a>
                </div>
            }
            { other &&
                <div>
                    <a href={"/download/document/sav/"+this.props.src} download={`${fileName}.${mime.getExtension(this.props.mime)}`}>
                    <IconButton color="secondary" title="Télécharger"><CloudDownloadRounded /></IconButton>
                    </a>
                </div>
            }
            </div>
        )
    }
}
export default FileSAV

//module.exports = FileSAV;

